import { DEFAULT_BLOTTER_SELECTION_MULTI_PARAMS, getTreeRowBlotterGroupColDef } from '@talos/kyoko';
import type { GridOptions } from 'ag-grid-community';
import type { PredictionMarketsPriceGridRow } from './rows';

export function getPredictionMarketsPriceGridOptions(): GridOptions<PredictionMarketsPriceGridRow> {
  return {
    treeData: true,
    getDataPath: row => row.dataPath,
    rowSelection: DEFAULT_BLOTTER_SELECTION_MULTI_PARAMS,
    autoGroupColumnDef: {
      headerName: 'Symbol',
      initialPinned: 'left',
      initialWidth: 220,
      suppressColumnsToolPanel: true,
      cellRendererParams: {
        suppressCount: true,
      },
      ...getTreeRowBlotterGroupColDef<PredictionMarketsPriceGridRow>(),
    },
  };
}
